<template>
<div>
    <!-- eslint-disable max-len -->
    <svg xmlns="http://www.w3.org/2000/svg" width="36.043" height="36.043" viewBox="0 0 36.043 36.043">
        <g transform="translate(-738.313 -92.05)">
            <g transform="translate(738.313 92.05)">
                <rect class="a" width="36.043" height="36.043" rx="18.022" transform="translate(0 0)" style="fill:#fff"/>
            </g>
            <rect class="b" width="13.297" height="13.242" rx="1" transform="translate(750.043 103.875)" style="fill:#707070"/>
        </g>
    </svg>
    <div
        :class="[
            'record__control position--absolute display--flex',
            { 'js--active': isRecording }
        ]"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="36.043" height="36.043" viewBox="0 0 36.043 36.043">
            <rect class="a" width="36.043" height="36.043" rx="18.022" transform="translate(0 0)" style="fill:#fff"/>
            <rect class="b" width="12.769" height="12.769" rx="6.385" transform="translate(11.637 11.637)" style="fill:#f7856a"/>
        </svg>
    </div>
</div>
</template>

<script>
export default {
    props: {
        isRecording: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss">
    .record {
        width: max-content;
        &__control {
            @include transform-position( 47%, false, false, 49%, translate( -50%, -50% ) );
            @include position-grid( center, center );
            display: none;
        }
        &__control.js--active {
            display: block;
        }
    }
</style>